import { render, staticRenderFns } from "./CompletedNotificationclose.vue?vue&type=template&id=32ab0e59&scoped=true&"
import script from "./CompletedNotificationclose.vue?vue&type=script&lang=js&"
export * from "./CompletedNotificationclose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab0e59",
  null
  
)

export default component.exports